import dayjs from "dayjs"

export class TradingFloorDetailModel {
  id: number | undefined
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new TradingFloorDetailModel(), obj)

    newObj.location = {
      countryId: obj.countryId,
      provinceId: obj.provinceId,
      districtId: obj.districtId,
      address: obj.address,
    }

    return newObj
  }

  public static assigns<T>(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}

export class UseUserInfoTradingFloorModelModel {
  id?: number
  emailAddress?: string
  password?: string
  isActive?: boolean
  phoneNumber?: string
  birthDate?: string
  gender?: boolean
  displayName?: string
  roleNames?: any[]
  userToOrganizationUnit?: any[]
  projectIds?: any[]
  jobTitle?: number
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new UseUserInfoTradingFloorModelModel(), obj)

    newObj.birthDate = obj.birthDate ? dayjs(obj.birthDate) : undefined

    return newObj
  }

  public static assigns<T>(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
